export const StockScreenerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M8.75 15C12.2018 15 15 12.2018 15 8.75C15 5.29822 12.2018 2.5 8.75 2.5C5.29822 2.5 2.5 5.29822 2.5 8.75C2.5 12.2018 5.29822 15 8.75 15Z" stroke="#EC8000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.1696 13.1696L17.5 17.5" stroke="#EC8000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
